module.exports = __webpack_public_path__ + "img/fr_pdf.11eebbec.png";